export default "__VITE_ASSET__D_NyB42T__"